import { Injectable } from "@angular/core";
import { MatDialog } from "@angular/material/dialog";
import { ActivatedRoute, Data, Router } from "@angular/router";
import { Browser } from "@capacitor/browser";
import { AuthService } from "@core/auth.service";
import { BehaviorSubject, of } from "rxjs";
import { defaultIfEmpty, filter, map, switchMap } from "rxjs/operators";
import { CommonVariable } from "src/app/app.constants";
import { MergeAccountPopupComponent } from "src/app/components/merge-account-popup/merge-account-popup.component";
import { AccountRepositoryService } from "src/app/pages/account/account-repository.service";
import { PreferenceComponent } from "src/app/pages/account/edit-account/preference/preference.component";
import { ChatbotService } from "src/app/services/chatbot.service";
import { CommonService } from "../common/common.service";
import { SafeStorageService } from "../safe-storage.service";
declare var window;
declare var dataLayer;
@Injectable({
  providedIn: "root",
})
export class ChatbotWidgetService {
  private storageKey = "chatbotWidgetVisible";
  private widgetVisibilitySubject = new BehaviorSubject<boolean>(this.getInitialState());

  widgetVisibility$ = this.widgetVisibilitySubject.asObservable();
  nickName = this.safeStorage.getItem("userNick");
  user$ = this.authService?.userDetails$;
  helpContent$ = this.accountService?.helpAndFaq();
  helpSupport = true;
  selectedLanguage: string;
  setInterval: number;
  favLink: string;
  attributes = {};
  public userId: string;
  public balance_points: number;
  public userData: Data;
  public balance: Data;
  public user: Data;
  faqindex: number[] = [1, 2, 3, 4, 5, 6];
  constructor(
    private authService: AuthService,
    private accountService: AccountRepositoryService,
    private matDialog: MatDialog,
    private router: Router,
    private route: ActivatedRoute,
    private chatService: ChatbotService,
    private commonService: CommonService,
    private safeStorage: SafeStorageService
  ) {
    if (this.safeStorage.getItem(this.storageKey) === null) {
      this.safeStorage.setItem(this.storageKey, "false");
    }
    // set chatlio details if it is not set at the time of line
    this.authService.userDetailsForLiveChat();

    this.setInterval = 6000;
    this.selectedLanguage = CommonVariable?.preferredLanguage;
    // Get userId from commonService instead of localStorage / other manual methods
    this.commonService.getUid("ChatbotWidgetService").subscribe((userId) => {
      this.userId = userId || null;

      // Do not set up Firebase listeners without a valid user ID
      if (!this.userId) {
        return;
      }

      // Balance observable using the correct userId
      this.balance = this.authService
        .getAngularFireStore(`users/${this.userId}/balance/current`, "snapshotChanges")
        .pipe(
          map((data: Data) => data?.payload?.data() ?? {}),
          defaultIfEmpty({})
        );

      this.balance.subscribe((data) => {
        this.balance_points = data?.points;
      });
    });


    // This method has been used to reset user redirect node.
    this.authService.resetUserRedirect("");

    // This method has been used for Set user attributes in the chatbot.
    this.user$.pipe(filter(() => location.href?.search("helpSupport") > -1))?.subscribe((u: Data) => {
      this.user = u;
    });

    window.BE_API = window.BE_API || {};
    if (typeof window.BE_API != "undefined") {
      /**
       * Calls ChatBotEvents with relevant data when a conversation starts.
       */
      window.BE_API = window.BE_API || {};
      window.BE_API.onConversationStart = () => {
        this.ChatBotEvents("Chatbot opened");
      };

      /**
       * Calls ChatBotEvents function when a conversation starts.
       */
      window.BE_API = window.BE_API || {};
      window.BE_API.onConversationEnd = () => {
        this.ChatBotEvents("Chatbot ended by user");
      };

      // Sets up a listener for incoming messages from the BE_API and check user is inactive for more than 30 mins
      window.BE_API = window.BE_API || {};
      window.BE_API.onMessage = () => {
        let ThirtyMins = 1800000;
        const zero = 0;
        const thousand = 1000;
        const ThirtyMinsInterval = setInterval(() => {
          ThirtyMins = ThirtyMins - 1;

          if (ThirtyMins <= zero) {
            clearInterval(ThirtyMinsInterval);
            this.ChatBotEvents("Chatbot ended by time out");
          }
        }, thousand);
      };
    }

    // This method has been used for handling window onclose event.
    window.BE_API = window.BE_API || {};
    window.BE_API.onChatWindowClose = () => {
      if (!window.BE_API?.isChatWindowHidden()) {
        window.BE_API.hideChatWindow();
        const chatbotChat = document.getElementById("chatbot-chat");
        if (chatbotChat && chatbotChat?.style?.display !== "none") {
          chatbotChat.style.display = "none";
        }
      }
      this.ChatBotEvents("Chatbot ended by user");
    };

    //This method has been used for redirecting user to selected page.
    this.user$.pipe(filter(() => location?.href.search("helpSupport") > -1)).subscribe(
      async (u: Data) => {
        if (u && u?.redirect) {
          if (u.redirect?.search("help") > -1) {
            this.router
              .navigateByUrl("mainTabs/tabs/account/helpSupport")
              .catch((err) => {
                return err;
              })
              .then(() => {
                this.authService.resetUserRedirect("");
                window.BE_API = window.BE_API || {};
                if (!window.BE_API?.isChatWindowHidden()) window.BE_API.hideChatWindow();
              })
              .catch((error) => {
                return error;
              });
          } else if (u.redirect.search("store") > -1) {
            this.router
              .navigateByUrl("/mainTabs/tabs/store")
              .catch((err) => {
                return err;
              })
              .then(() => {
                this.authService.resetUserRedirect("");
                window.BE_API = window.BE_API || {};
                if (!window.BE_API?.isChatWindowHidden()) window.BE_API.hideChatWindow();
              })
              .catch((error) => {
                return error;
              });
          } else if (u.redirect.search("voucher") > -1) {
            this.router
              .navigateByUrl("mainTabs/tabs/voucher")
              .catch((err) => {
                return err;
              })
              .then(() => {
                this.authService.resetUserRedirect("");
                window.BE_API = window.BE_API || {};
                if (!window.BE_API?.isChatWindowHidden()) window.BE_API.hideChatWindow();
              })
              .catch((error) => {
                return error;
              });
          } else if (u.redirect.search("syndicate") > -1) {
            this.router
              .navigateByUrl("mainTabs/tabs/syndicate")
              .catch((err) => {
                return err;
              })
              .then(() => {
                this.authService.resetUserRedirect("");
                window.BE_API = window.BE_API || {};
                if (!window.BE_API?.isChatWindowHidden()) window.BE_API.hideChatWindow();
              })
              .catch((error) => {
                return error;
              });
          } else if (u.redirect.search("account") > -1) {
            this.router
              .navigateByUrl("mainTabs/tabs/account")
              .catch((err) => {
                return err;
              })
              .then(() => {
                this.authService.resetUserRedirect("");
                window.BE_API = window.BE_API || {};
                if (!window.BE_API?.isChatWindowHidden()) window.BE_API.hideChatWindow();
              })
              .catch((error) => {
                return error;
              });
          } else if (u.redirect.search("game") > -1) {
            this.router
              .navigateByUrl("mainTabs/tabs/game")
              .catch((err) => {
                return err;
              })
              .then(() => {
                this.authService.resetUserRedirect("");
                window.BE_API = window.BE_API || {};
                if (!window.BE_API?.isChatWindowHidden()) window.BE_API.hideChatWindow();
              })
              .catch((error) => {
                return error;
              });
          } else if (u.redirect?.search("profile&token") > -1) {
            this.router
              .navigateByUrl("mainTabs/tabs/account/profile")
              .catch((err) => {
                return err;
              })
              .then(() => {
                this.authService.resetUserRedirect("");
                window.BE_API = window.BE_API || {};
                if (!window.BE_API?.isChatWindowHidden()) window.BE_API.hideChatWindow();
              })
              .catch((error) => {
                return error;
              });
          } else if (u.redirect?.search("profile_payments&token") > -1) {
            this.router
              .navigateByUrl("mainTabs/tabs/account/wallet")
              .catch((err) => {
                return err;
              })
              .then(() => {
                this.authService.resetUserRedirect("");
                window.BE_API = window.BE_API || {};
                if (!window.BE_API?.isChatWindowHidden()) window.BE_API.hideChatWindow();
              })
              .catch((error) => {
                return error;
              });
          } else if (u.redirect?.search("registration&Prosub_ID") > -1) {
            this.router
              .navigateByUrl("mainTabs/tabs/voucher")
              .catch((err) => {
                return err;
              })
              .then(() => {
                this.authService.resetUserRedirect("");
                window.BE_API = window.BE_API || {};
                if (!window.BE_API?.isChatWindowHidden()) window.BE_API.hideChatWindow();
              })
              .catch((error) => {
                return error;
              });
          } else if (u.redirect?.search("voucher_redeem&token") > -1) {
            this.router
              .navigateByUrl("mainTabs/tabs/voucher")
              .catch((err) => {
                return err;
              })
              .then(() => {
                this.authService.resetUserRedirect("");
                window.BE_API = window.BE_API || {};
                if (!window.BE_API?.isChatWindowHidden()) window.BE_API.hideChatWindow();
              })
              .catch((error) => {
                return error;
              });
          } else if (u.redirect?.search("profile_password&token") > -1) {
            this.router
              .navigateByUrl("mainTabs/tabs/account/profile")
              .catch((err) => {
                return err;
              })
              .then(() => {
                this.authService.resetUserRedirect("");
                window.BE_API = window.BE_API || {};
                if (!window.BE_API?.isChatWindowHidden()) window.BE_API.hideChatWindow();
              })
              .catch((error) => {
                return error;
              });
          } else if (u.redirect?.search("payment&Prosub_ID") > -1) {
            this.router
              .navigateByUrl("mainTabs/tabs/syndicate")
              .catch((err) => {
                return err;
              })
              .then(() => {
                this.authService.resetUserRedirect("");
                window.BE_API = window.BE_API || {};
                if (!window.BE_API?.isChatWindowHidden()) window.BE_API.hideChatWindow();
              })
              .catch((error) => {
                return error;
              });
          } else if (u.redirect.search("game_center&gameId") > -1) {
            this.router
              .navigateByUrl("games/replayable/235")
              .catch((err) => {
                return err;
              })
              .then(() => {
                this.authService.resetUserRedirect("");
                window.BE_API = window.BE_API || {};
                if (!window.BE_API?.isChatWindowHidden()) window.BE_API.hideChatWindow();
              })
              .catch((error) => {
                return error;
              });
          } else if (u.redirect.search("merge_accounts&token") > -1) {
            this.matDialog.open(MergeAccountPopupComponent, {
              height: "100%",
              width: "100%",
            });
            setTimeout(() => {
              const chatbotChat = document.getElementById("chatbot-chat");
              if (chatbotChat && chatbotChat.style.display !== "none") {
                chatbotChat.style.display = "none";
              }
            }, 100);
            this.authService.resetUserRedirect("");
            window.BE_API = window.BE_API || {};
            if (!window.BE_API?.isChatWindowHidden()) window.BE_API.hideChatWindow();
          } else if (u.redirect?.search("profile_preferences&token") > -1) {
            this.matDialog.open(PreferenceComponent, {
              height: "100%",
              width: "100%",
              panelClass: "modal-fullScreen",
              data: "chatbot",
            });
            setTimeout(() => {
              const chatbotChat = document.getElementById("chatbot-chat");
              if (chatbotChat && chatbotChat.style.display !== "none") {
                chatbotChat.style.display = "none";
              }
            }, 100);
            this.authService.resetUserRedirect("");
            window.BE_API = window.BE_API || {};
            if (!window.BE_API?.isChatWindowHidden()) window.BE_API.hideChatWindow();
          } else if (u.redirect.search("refer_a_friend&Prosub_ID") > -1) {
            this.router
              .navigateByUrl("mainTabs/tabs/account")
              .catch((err) => {
                return err;
              })
              .then(() => {
                this.authService.resetUserRedirect("");
                window.BE_API = window.BE_API || {};
                if (!window.BE_API?.isChatWindowHidden()) window.BE_API.hideChatWindow();
              })
              .catch((error) => {
                return error;
              });
          } else if (u.redirect.search("dashboard&token") > -1) {
            this.router
              .navigateByUrl("mainTabs/tabs/account")
              .catch((err) => {
                return err;
              })
              .then(() => {
                this.authService.resetUserRedirect("");
                window.BE_API = window.BE_API || {};
                if (!window.BE_API?.isChatWindowHidden()) window.BE_API.hideChatWindow();
              })
              .catch((error) => {
                return error;
              });
          } else if (u.redirect?.search("support&token") > -1) {
            this.chatService.changeReload(true); // Set the value in the service
            this.router
              .navigateByUrl("account/livechat")
              .catch((err) => {
                return err;
              })
              .then(() => {
                this.authService.resetUserRedirect("");
                window.BE_API = window.BE_API || {};
                if (!window.BE_API?.isChatWindowHidden()) window.BE_API.hideChatWindow();
              })
              .catch((error) => {
                return error;
              });
            setTimeout(() => {
              const chatbotChat = document.getElementById("chatbot-chat");
              if (chatbotChat && chatbotChat.style.display !== "none") {
                chatbotChat.style.display = "none";
              }
            }, 100);
          } else if (u.redirect?.search("mgm") > -1) {
            this.router
              .navigateByUrl("refer-friends")
              .catch((err) => {
                return err;
              })
              .then(() => {
                this.authService.resetUserRedirect("");
                window.BE_API = window.BE_API || {};
                if (!window.BE_API?.isChatWindowHidden()) window.BE_API.hideChatWindow();
              })
              .catch((error) => {
                return error;
              });
          } else if (u.redirect?.search("subscription_settings&token") > -1) {
            this.router
              .navigateByUrl("subscription-settings")
              .catch((err) => {
                return err;
              })
              .then(() => {
                this.authService.resetUserRedirect("");
                window.BE_API = window.BE_API || {};
                if (!window.BE_API?.isChatWindowHidden()) window.BE_API.hideChatWindow();
              })
              .catch((error) => {
                return error;
              });
          }

          setTimeout(() => {
            const chatbotChat = document.getElementById("chatbot-chat");
            if (chatbotChat && chatbotChat.style.display !== "none") {
              chatbotChat.style.display = "none";
            }
          }, 100);
          return;
        }
      },
      (err) => {
        return err;
      },
      () => {
        return;
      }
    ),
      (err) => {
        return err;
      },
      () => {
        return;
      };
  }
  private getInitialState(): boolean {
    return this.safeStorage.getItem(this.storageKey) === "true";
  }

  get showWidget(): boolean {
    return this.widgetVisibilitySubject.value;
  }

  toggleWidget() {
    const newState = !this.showWidget;
    this.setWidgetVisibility(newState);
  }

  setWidgetVisibility(visible: boolean) {
    this.safeStorage.setItem(this.storageKey, String(visible));
    this.widgetVisibilitySubject.next(visible);
  }
  getFurtherData(uri: string) {
    uri += "?lang=" + this.authService?.selectedlanguage$?.value;
    Browser.open({ url: uri });
  }

  // This method has been used for navigate to home page.
  goBack() {
    this.router.navigateByUrl("mainTabs/tabs/home");
  }
  // This method has been used for open new chat window.
  public openChatBot() {
    let userId = null;
    this.authService.getUid$("SyndicateRepositoryService").pipe(
      switchMap((userId) => {
        userId = userId;
        return of(userId) || of(null);
      }));
    window.BE_API = window.BE_API || {};

    if (typeof window?.BE_API !== "undefined") {
      // Log user information
      if (this.user?.name && this.user?.name !== "" && this.user.name !== null && this.user?.name !== "null")
        this.attributes["default_name"] = this.user.name;
      if (this.user?.email && this.user?.email !== "" && this.user?.email !== null && this.user?.email !== "null")
        this.attributes["default_email"] = this.user.email;
      if (
        this.user?.pwa_segment_status &&
        this.user.pwa_segment_status !== "" &&
        this.user.pwa_segment_status !== null &&
        this.user.pwa_segment_status !== "null"
      )
        this.attributes["user_segment"] = this.user?.pwa_segment_status;
      if (
        this.user?.onboard_state &&
        this.user.onboard_state !== "" &&
        this.user.onboard_state !== null &&
        this.user.onboard_state !== "null"
      ) {
        this.attributes["user_state"] = this.user?.onboard_state;
        this.attributes["onboard_state"] = this.user?.onboard_state;
        this.attributes["user_phase"] = this.user?.onboard_state;
      }
      if (CommonVariable?.userIP && CommonVariable.userIP !== "" && CommonVariable.userIP !== null)
        this.attributes["default_ip"] = CommonVariable.userIP;

      this.attributes["default_username"] = userId;
      this.attributes["userId"] = userId;
      this.attributes["default_language"] = this.selectedLanguage ?? "en";
      this.attributes["default_source"] = "pwa";
      this.attributes["default_url"] = "https://app.lottosocial.com";

      if (typeof window.BE_API?.setSessionAttributes === "function") {
        window.BE_API?.setSessionAttributes(this.attributes);
      }

      if (typeof window.BE_API?.setUserAttributes === "function") {
        window.BE_API?.setUserAttributes(this.attributes);
      }

      if (typeof window.BE_API?.openChatWindow === "function") {
        window.BE_API.openChatWindow();
      }

      this.router.navigate([], {
        queryParams: {
          "chat-initiated": "1",
        },
        queryParamsHandling: "merge",
      });

      try {
        dataLayer?.push({
          event: "support_event",
          user_id: userId,
          support_name: "Chatbot",
        });
      } catch (error) {
        console.error("Error pushing to data layer:", error);
        return error;
      }

      setTimeout(() => {
        const chatbotChat = document.getElementById("chatbot-chat");
        if (chatbotChat) {
          chatbotChat.style.display = "block";
        }
      }, 100);
    }
  }

  /**
   * Tracks a chatbot event with analytics.
   *
   * @param {string} event_name - The name of the event being tracked.
   */
  public ChatBotEvents(event_name: string) {
    this.user$?.subscribe((user: Data) => {
      this.userData = user;
    });

    window.analytics.track(
      event_name,
      {
        points_balance: this.balance_points,
        user_age: this.dateDifference(this.userData?.timestamp.toDate()),
        user_id: this.userId,
        user_phase: this.userData?.onboard_state,
        user_state: this.userData?.pwa_segment_status,
        userId: this.userId,
      },
      {
        context: {
          library: {},
        },
      }
    );
  }

  // Calculate time between two dates
  public dateDifference(actualDate) {
    const date1 = actualDate;
    const date2: Date = new Date();
    const thousand = 1000;
    const zero = 0;
    const one = 1;
    const sixty = 60;
    const thirtyOne = 31;
    const twentyFour = 24;
    const twelwe = 12;
    let message = "";
    const diffInSeconds: number = Math.abs(date2.getTime() - date1.getTime()) / thousand;
    const hours: number = Math.floor((diffInSeconds / sixty / sixty) % twentyFour);
    const minutes: number = Math.floor((diffInSeconds / sixty) % sixty);
    const days: number = Math.floor(diffInSeconds / sixty / sixty / twentyFour);
    const months: number = Math.floor(days / thirtyOne);
    const years: number = Math.floor(months / twelwe);

    if (years === zero && months === zero) {
      // show in days if no years / months
      if (days > zero) {
        if (days === one) {
          message = days + " day";
        } else {
          message = days + " days";
        }
      } else if (hours > zero) {
        // show in hours if no years / months / days
        if (hours === one) {
          message = hours + " hour";
        } else {
          message = hours + " hours";
        }
      } else {
        // show in minutes if no years / months / days / hours
        if (minutes === one) {
          message = minutes + " minute";
        } else {
          message = minutes + " minutes";
        }
      }
    } else if (years === zero && months > zero) {
      // show in months if no years
      if (months === one) {
        message = months + " month";
      } else {
        message = months + " months";
      }
    } else if (years > zero) {
      // show in years if years exist
      if (years === one) {
        message = years + " year";
      } else {
        message = years + " years";
      }
    }
    return message;
  }

  // THis method will be used to get the link of the faq
  getFaqLink(faq: string) {
    // this.translate
    //   .get([
    //     "help-support.faq1Link",
    //     "help-support.faq2Link",
    //     "help-support.faq3Link",
    //     "help-support.faq4Link",
    //     "help-support.faq5Link",
    //     "help-support.faq6Link",
    //   ])
    //   .subscribe(
    //     (res) => {
    //       const faqs = {
    //         faq1: res["help-support.faq1Link"],
    //         faq2: res["help-support.faq2Link"],
    //         faq3: res["help-support.faq3Link"],
    //         faq4: res["help-support.faq4Link"],
    //         faq5: res["help-support.faq5Link"],
    //         faq6: res["help-support.faq6Link"],
    //       };
    //       this.favLink = faqs[faq];
    //       this.openNewWindowData(this.favLink);
    //     },
    //     (err) => {
    //       return err;
    //     }
    //   );
  }
  public openNewWindowData(uri: string): void {
    try {
      Browser.open({ url: uri });
    } catch (err) {
      return err;
    }
  }
}
